export var  Global = {
    url_dev: 'http://localhost:8081/new_apigeincca/public/api/',
    url_v: 'https://apivalerana.geincca.com/api/',
    url: 'https://apiorinoco.geincca.com/api/',
}